export default function EmptyState({ icon, title, message, action }) {
  return (
    <div style={{
      padding: '48px 32px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 8,
    }}>
      {icon && (
        <div style={{ marginBottom: 4, color: 'var(--color-text-tertiary)' }}>
          {icon}
        </div>
      )}
      <div style={{
        fontSize: 'var(--font-size-md)',
        fontWeight: 'var(--font-weight-normal)',
        color: 'var(--color-text-primary)',
      }}>
        {title}
      </div>
      {message && (
        <div style={{
          fontSize: 'var(--font-size-base)',
          color: 'var(--color-text-tertiary)',
          maxWidth: 320,
          lineHeight: 1.6,
        }}>
          {message}
        </div>
      )}
      {action && (
        <div style={{ marginTop: 8 }}>
          {action}
        </div>
      )}
    </div>
  );
}